import { NavTreeState, TreeTypes } from "../hooks/NavTreeState"

export const getRouteFromTree = (
  tree: NavTreeState,
  type: TreeTypes,
  key: string
) => {
  return tree[type][key] ? `/${tree[type][key]}` : "/"
}
